const GET_INFO_IGARASHI = 'GET_INFO_IGARASHI'
const GET_INFO_IGARASHI_SUCCESS = 'GET_INFO_IGARASHI_SUCCESS'


const CommonType = {
  GET_INFO_IGARASHI,
  GET_INFO_IGARASHI_SUCCESS

}

export default CommonType
